import axios from 'axios';

const inferredBase =
  typeof window !== 'undefined' && window.location && window.location.origin
    ? window.location.origin
    : 'http://localhost:8000';
const rawEnvBase = process.env.REACT_APP_API_URL;
let apiBaseURL = inferredBase;
if (rawEnvBase) {
  if (inferredBase.startsWith('https://') && rawEnvBase.startsWith('http://')) {
    apiBaseURL = inferredBase;
  } else {
    apiBaseURL = rawEnvBase;
  }
}

const api = axios.create({
  baseURL: apiBaseURL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

const isDevBypass = process.env.REACT_APP_DEV_MODE_BYPASS_AUTH === 'true';
let refreshRequest = null;

const triggerRefresh = () => {
  if (!refreshRequest) {
    refreshRequest = api.post('/api/auth/refresh', {}, { skipAuthRefresh: true }).finally(() => {
      refreshRequest = null;
    });
  }
  return refreshRequest;
};

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const originalRequest = error.config || {};

    const shouldAttemptRefresh =
      status === 401 &&
      !isDevBypass &&
      !originalRequest._retry &&
      !originalRequest.skipAuthRefresh;

    if (shouldAttemptRefresh) {
      originalRequest._retry = true;

      try {
        await triggerRefresh();
        return api(originalRequest);
      } catch (refreshError) {
        const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
        if (currentPath !== '/login') {
          window.location.assign('/login');
        }
        return Promise.reject(refreshError);
      }
    }

    if (status === 401 && !isDevBypass && !originalRequest.skipAuthRefresh) {
      const currentPath = typeof window !== 'undefined' ? window.location.pathname : '';
      if (currentPath !== '/login') {
        window.location.assign('/login');
      }
    }

    return Promise.reject(error);
  }
);

export default api;
